import { render, staticRenderFns } from "./DeleteUser.vue?vue&type=template&id=4e1c773a&scoped=true&lang=pug&"
import script from "./DeleteUser.vue?vue&type=script&lang=js&"
export * from "./DeleteUser.vue?vue&type=script&lang=js&"
import style0 from "./DeleteUser.vue?vue&type=style&index=0&id=4e1c773a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1c773a",
  null
  
)

export default component.exports